import React from 'react'

// Original vectors from Figma frame 217, node 302:773.
const HygieneAttentionIcon = ({ size = 48 }) => (
  <svg
    width={size}
    height={size}
    viewBox="122 754 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M131.755 769.949C132.144 767.851 133.185 765.928 134.73 764.456C136.298 762.964 138.581 762.502 140.605 763.268L143.42 764.333C145.082 764.962 146.918 764.962 148.58 764.333L151.395 763.268C153.419 762.502 155.702 762.964 157.27 764.456C158.815 765.928 159.856 767.851 160.245 769.949L161.19 775.052C161.695 777.782 160.79 780.582 158.782 782.499C157.531 783.692 156.824 785.346 156.824 787.075V790.77C156.824 794.901 153.474 798.25 149.343 798.25H148.957L149.578 790.611C149.751 788.484 148.071 786.662 145.937 786.662C143.802 786.662 142.123 788.484 142.295 790.611L142.916 798.25H142.657C138.526 798.25 135.176 794.901 135.176 790.77V787.075C135.176 785.346 134.469 783.692 133.218 782.499C131.21 780.582 130.305 777.782 130.81 775.052L131.755 769.949Z"
      fill="#8FB4FF"
    />
    <circle cx="131.5" cy="781.5" r="4.5" fill="white" stroke="#8FB4FF" strokeWidth="2" />
    <circle cx="155" cy="764" r="7" fill="white" stroke="#8FB4FF" strokeWidth="2" />
    <circle cx="162" cy="771" r="5" fill="white" stroke="#8FB4FF" strokeWidth="2" />
  </svg>
)

export default HygieneAttentionIcon
